import Cookies from 'js-cookie'
const TokenKey = 'vue_admin_template_token'

export function getToken() {
  let k = Cookies.get(TokenKey)
  return k
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
